export default 'personal';